import { render, staticRenderFns } from "./relate-config.vue?vue&type=template&id=55b7effa&scoped=true"
import script from "./relate-config.vue?vue&type=script&lang=js"
export * from "./relate-config.vue?vue&type=script&lang=js"
import style0 from "./relate-config.vue?vue&type=style&index=0&id=55b7effa&prod&lang=scss&scoped=true"
import style1 from "./relate-config.vue?vue&type=style&index=1&id=55b7effa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7effa",
  null
  
)

export default component.exports